import qs from 'qs'
import axios from 'axios'
import Toast from '@nutui/nutui/dist/packages/toast/toast.js'
import '@nutui/nutui/dist/packages/toast/toast.css'
import wx from 'weixin-js-sdk'


/**
 * 当前上下文
 */
let that

/**
 * 接口汇总
 * @module api
 */

let api = {
  /**
   * 品牌商id
   */
  agentId: localStorage.getItem('agentId') || 63,
  /**
   * 商户d
   */
  merId: localStorage.getItem('merId') || 19,
  /**
   * 门店id
   */
  storeId: localStorage.getItem('storeId'),
  /**
   * 代理商平台id
   */
  agentplatId: 0,
  /**
   * 用户信息
   * @type {object}
   * @property {boolean} configCode 是否有额外用户config信息
   * @property {object} config 用户包含的额外config信息
   */
  user: null,
  /**
   * systemCode 系统信息只有为 1 时可以获取
   * @type {number}
   */
  systemCode: 0,
  /**
   * 系统信息
   * @type {{merSystemData: object, hangSellData: object, textData: object, systemData: object, cardNewData: object, wholesaleSetData: object, cloudCabinData: object}} system 系统信息
   */
  system: {
    systemData: {},
    merSystemData: {},
    cardNewData: {},
    textData: {},
    hangSellData: {},
    wholesaleSetData: {},
    cloudCabinData: {},
    sellerInfoData: {}
  },
  /**
   * 初始化api
   * @param vue 传入vue实例
   */
  init: function (vue) {
    that = this
    //赋值 user信息
    this.user = JSON.parse(localStorage.getItem('user'))
    //注入vue 上下文
    that.Vue = vue
    //挂载到vue 原型链
    vue.prototype.$api = api
    return api
  },
  /**
   * 发起post请求
   *
   * @method post
   * @for api
   * @param {Object} config 配置参数
   * @param {string} config.url 请求url地址
   * @param {Object=} config.data 请求参数
   * @param {boolean=} config.loading 是否显示进度条 默认显示
   * @param {boolean=} config.login 是否需要登录权限 访问请求 默认需要
   * @return Promise  自行捕获 then 处理成功事件, catch 捕获处理失败事件
   */
  post: (config) => {
    let header = {}
    if (config.login == void 0) {
      config.login = true
    }
    let token = localStorage.getItem('access_token')
    if (token != null && token != '' && config.login) {
      header['Authorization'] = token
    }
    let loading = null == config.loading ? true : config.loading
    let loadingComponent
    if (loading) {
      loadingComponent = Toast.loading('加载中...')
    }
    return new Promise((resolve, reject) => {
      axios.post(config.url,
        qs.stringify(config.data),
        {
          headers: header
        }).then(res => {
        if (loading) {
          loadingComponent.hide()
        }
        message(res.data.code, res.data.msg)
        if (res.data.code === 1) {
          resolve(res.data)
        } else {
          reject(res.data)
        }
      }).catch(err => {
        if (loading) {
          loadingComponent.hide()
        }
        message(err.response.status, err.response.data.message)
        reject(err)
      })
    })
  },
  /**
   * 发起get 请求
   *
   * @method get
   * @for api
   * @param {Object} config 配置参数
   * @param {string} config.url 请求url地址
   * @param {?Object} config.id get请求可以单独传此字段,当传入此字段时 url结尾必须为 /
   * @param {?Object} config.data 请求参数
   * @param {?boolean} config.loading 是否显示进度条 默认显示
   * @param {?boolean} config.login 是否需要登录权限 访问请求 默认需要
   * @return Promise  自行捕获 then 处理成功事件, catch 捕获处理失败事件
   */
  get: (config) => {
    let loading = null == config.loading ? true : config.loading
    let loadingComponent
    if (loading) {
      loadingComponent = Toast.loading('加载中...', {
        coverColor: 'rgba(0,0,0,0.5)'
      })
    }
    return new Promise((resolve, reject) => {
      axios.get(config.url + (config.id ? config.id : ''),
        {
          headers: {Authorization: localStorage.getItem('access_token')}
        }).then(res => {
        if (loading) {
          loadingComponent.hide()
        }
        message(res.data.code, res.data.msg)
        if (res.data.code === 1) {
          resolve(res.data)
        } else {
          reject(res.data)
        }
      }).catch(err => {
        if (loading) {
          loadingComponent.hide()
        }
        message(err.data.code, err.data.msg)
        reject(err)
      })
    })
  },
  /**
   * 发起delete 请求
   *
   * @method delete
   * @for api
   * @param {{url: string, id: string,loading: ?boolean, target: ?HTMLElement, login: ?boolean}} config 配置参数
   * @param {string} config.url 请求url地址
   * @param {string} config.id 需要删除的主键id
   * @param {?boolean} config.loading 是否显示进度条 默认显示
   * @param {?boolean} config.login 是否需要登录权限 访问请求 默认需要
   * @return Promise  自行捕获 then 处理成功事件, catch 捕获处理失败事件
   */
  delete: (config) => {
    let loading = null == config.loading ? true : config.loading
    let loadingComponent
    if (loading) {
      loadingComponent = Toast.loading('加载中...', {
        coverColor: 'rgba(0,0,0,0.5)'
      })
    }
    return new Promise((resolve, reject) => {
      axios.delete(config.url + '/' + config.id,
        {
          headers: {Authorization: localStorage.getItem('access_token')}
        }).then(res => {
        if (loading) {
          loadingComponent.hide()
        }
        message(res.data.code, res.data.msg)
        if (res.data.code === 1) {
          resolve(res.data)
        } else {
          reject(res.data)
        }
      }).catch(err => {
        if (loading) {
          loadingComponent.hide()
        }
        message(err.data.code, err.data.msg)
        reject(err)
      })
    })
  },
  /**
   * 发起upload 文件上传请求
   *
   * @method post
   * @for api
   * @param {Object} config 配置参数
   * @param {string} config.url 请求url地址
   * @param {?Object} config.data 请求参数
   * @param {?boolean} config.login 是否需要登录权限 访问请求 默认需要
   * @param {Function} config.onUploadProgress  上传进度回调
   * @return Promise  自行捕获 then 处理成功事件, catch 捕获处理失败事件
   */
  upload: (config) => {
    let header = {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    if (config.login == void 0) {
      config.login = true
    }
    let token = localStorage.getItem('access_token')
    if (token != null && token != '' && config.login) {
      header['Authorization'] = token
    }
    return new Promise((resolve, reject) => {
      axios.post(config.url, config.data,
        {
          headers: header,
          onUploadProgress: progressEvent => {
            //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
            if (progressEvent.lengthComputable) {
              if (typeof config.onUploadProgress === 'function') {
                config.onUploadProgress(progressEvent)
              }
            }
          }
        }).then(res => {
        message(res.data.code, res.data.msg)
        if (res.data.code === 1) {
          resolve(res.data)
        } else {
          reject(res.data)
        }
      }).catch(err => {
        //message(err.response.data.status, err.response.data.statusText);
        reject(err)
      })
    })
  },
  /**
   * deviceLogin 登录注册接口
   *
   * @method login
   * @for api
   * @param {Object} form 配置参数
   * @param {string} form.username 帐号/手机号码
   * @param {string} form.password 密码
   * @param {number} form.path 记录上次跳转地址
   * @return Promise  自行捕获 then 处理成功事件, catch 捕获处理失败事件
   */
  deviceLogin: function (form) {
    let header = {
      'Authorization': 'Basic Zm9udDoxMjM0NTY='
    }
    let loadingComponent = Toast.loading('登录中...', {
      coverColor: 'rgba(0,0,0,0.5)'
    })
    return new Promise((resolve, reject) => {
      axios.post('/auth/login/device/account/weixin',
        qs.stringify({
          apphost: window.location.host,
          path: form.path ? form.path : window.location.pathname + window.location.search,
          username: form.username,
          password: form.password
        }),
        {
          headers: header
        }).then(res => {
        if (loading) {
          loadingComponent.hide()
        }
        if (res.data.code != 0 && res.data.code != -1 && res.data.code != -2) {
          let {access_token, user, token_type} = res.data.data
          if (res.data.msg != void 0) {
            Toast.success(res.data.msg == 'success' ? '' : res.data.msg)
          }
          if (user.merIds == null) {
            user.merIds = user.iv
          }
          this.user = user
          this.merId = user.merId
          this.storeId = user.storeId
          localStorage.setItem('user', JSON.stringify(user))
          localStorage.setItem('access_token', token_type + ' ' + access_token)
          localStorage.setItem('merId', user.merId)
          localStorage.setItem('storeId', user.storeId)
          //window.location.replace(res.data.url)
          resolve(res.data)
        } else {
          if (res.data.msg != void 0) {
            Toast.fail(res.data.msg)
          } else {
            Toast.fail('登录失败')
          }
          reject(res)
        }
      }).catch(err => {
        if (loading) {
          loadingComponent.hide()
        }
        Toast.fail('登录失败')
        reject(err)
      })
    })
  },
  login: (config) => {
    let loadingComponent = Toast.loading('登录中...', {
      coverColor: 'rgba(0,0,0,0.5)'
    })
    return new Promise((resolve, reject) => {
      axios.post('' + config.url,
        qs.stringify(config.data),
        {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic Zm9udDoxMjM0NTY='
          }
        }).then(res => {
        if (res.data.code != 0 && res.data.code != -1 && res.data.code != -2) {
          let {access_token, code, user, token_type} = res.data
          if (res.data.msg != void 0) {
            Toast.success(res.data.msg == 'success' ? '' : res.data.msg)
          }
          localStorage.setItem('user', JSON.stringify(user))
          localStorage.setItem('access_token', token_type + ' ' + access_token)
          localStorage.setItem('merId', user.merId)
          localStorage.setItem('storeId', user.storeId)
          resolve(res.data)
          loadingComponent.hide()
        } else {
          if (res.data.msg != void 0) {
            Toast.fail(res.data.msg)
          } else {
            Toast.fail('登录失败')
          }
          reject(res)
          loadingComponent.hide()
        }
      }).catch(err => {
        if (err.data.msg != void 0) {
          Toast.fail(err.data.msg)
        } else {
          Toast.fail('登录失败')
        }
        reject(err)
        loadingComponent.hide()
      })
    })
  },
  /**
   * getUser 获取用户信息
   *
   * @method getUser
   * @for api
   * @param {?Object} config 配置参数
   * @param {string} config.sync 为true时同步获取服务器最新用户信息
   * @return Promise  自行捕获 then 处理成功事件, catch 捕获处理失败事件
   */
  getUser: function (config) {
    config = config ? config : {
      sync: false
    }
    return new Promise((resolve, reject) => {
      let user = this.user || JSON.parse(localStorage.getItem('user'))
      if (user == null || config.sync) {
        this.post({
          url: '/device/api/device/device-user/getUser',
          data: {
            merId: this.merId
          }
        }).then(res => {
          //设置用户信息
          localStorage.setItem('user', JSON.stringify(res.data))
          that.user = res.data
          that.getConfig()
          message(res.data.code, res.data.msg)
          if (res.data.code == 0) {
            reject({
              code: 0,
              msg: res.data.msg || '获取失败'
            })
          } else {
            resolve({
              code: 1,
              user: res.data
            })
          }
        }).catch(err => {
          message(err.code, err.msg)
          reject({
            code: 0,
            msg: err.msg || '获取失败'
          })
        })
      } else {
        resolve({
          code: 1,
          user: this.user
        })
      }
    })
  },
  /**
   * 根据设备详情做登录
   */
  getDevice (config) {
    //根据设备id查询详情
    this.post({
      url: '/device/api/device/detail',
      data: {
        deviceId: config.query.deviceId
      },
      login: false
    }).then(res => {
        localStorage.setItem('device', JSON.stringify(res.data))
        if (this.merId != res.data.merId) {
          localStorage.removeItem('access_token')
          localStorage.removeItem('user')
          this.merId = res.data.merId
          localStorage.setItem('merId', this.merId)
        }
        this.auth({path: config.path, query: config.query, fullPath: config.fullPath}).catch(() => {
          return
        })
      }
    )
  },
  /**
   * 授权
   * @param {{fullPath: string, path: string, query: Dictionary<string>}} config
   * @param {?string} config.path 请求地址
   * @param {?string} config.path 页面地址
   * @param {?string} config.query 页面传递参数
   * @param {?string} config.fullPath 页面完整地址(含参数)
   * @return {Promise<unknown>}
   */
  auth: function (config) {
    let path = null
    if (config) {
      path = config.fullPath
    }
    return new Promise((resolve, reject) => {
      let loadingComponent = Toast.loading('加载中...', {
        coverColor: 'rgba(0,0,0,0.5)'
      })
      let webType = localStorage.getItem('webType')
      let url = '/device/api/device/device-user/alipay/auth'
      if (webType == 'weixin') {
        url = '/device/api/device/device-user/wx/auth'
      } else {
        url = '/device/api/device/device-user/alipay/auth'
      }
      axios.post(url,
        qs.stringify({
          apphost: window.location.host,
          path: path || (window.location.pathname + window.location.search),
          merId: this.merId,
          agentId: this.agentId
        }), {
          headers: {'Authorization': 'Basic Zm9udDoxMjM0NTY='}
        }).then(res => {
        loadingComponent.hide()
        window.location.replace(res.data.data.url)
      }).catch(() => {
        Toast.fail('授权失败')
        loadingComponent.hide()
        reject({
          code: 0
        })
      })
    })
  },
  //获取url
  getUrl: function () {
    return new Promise((resolve, reject) => {
      let url = sessionStorage.getItem('url')
      if (url != null) {
        resolve(url)
      } else {
        let header = {}
        let token = sessionStorage.getItem('access_token')
        if (token != null && token != '') {
          header['Authorization'] = token
        }
        axios.post('/file/qn/url',
          qs.stringify({bucket: 'mbs', isHttp: 1}),
          {
            headers: header
          }).then(res => {
          message(res.data.code, res.data.msg)
          if (res.data.code === 1) {
            let url = decodeURIComponent(res.data.data)
            sessionStorage.setItem('url', url)
            resolve(url)
          } else {
            reject(res.data)
          }
        }).catch(err => {
          message(err.data.code, err.data.msg)
          reject(err)
        })
      }
    })
  },
  /**
   * 获取用户额外信息 调用此方法需要用户登录后才能获取到信息
   * @return {Promise<unknown>} 返回获取到的config信息
   */
  getConfig: function () {
    return new Promise((resolve, reject) => {
      this.post({
        url: '/device/api/device/device-user/getByConfig',
        data: {
          uid: this.user.uid,
          merId: this.merId
        }
      }).then(res => {
        that.user.configCode = 1
        that.user.config = res.data
        //设置用户信息
        localStorage.setItem('user', JSON.stringify(that.user))
        resolve({
          code: 1,
          config: res.data
        })
      }).catch(err => {
        reject({
          code: 0,
          msg: err.msg || '获取失败'
        })
      })
    })
  },
  /**
   * 微信统一支付接口
   * @method wxPay
   * @param {Object} config 配置参数
   * @param {string} config.appid  必填，公众号的唯一标识
   * @param {string} config.timeStamp 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
   * @param {string} config.nonceStr 支付签名随机串，不长于 32 位
   * @param {string} config.package 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
   * @param {string} config.signType 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
   * @param {string} config.sign 支付签名
   * @param {string} config.url 请求url地址
   * @param {?Object} config.data 请求参数
   * @return {Promise<unknown>}
   */
  wxPay: function (config) {
    return new Promise((resolve, reject) => {
      this.post({
        url: '/seller/api/weixin/weixin-account/config',
        data: {
          agentId: this.agentId,
          signUrl: encodeURIComponent(window.location.href)
        }
      }).then(res => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: config.appid, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        wx.ready(() => {
          wx.chooseWXPay({
            appId: config.appid,
            timestamp: config.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: config.nonceStr, // 支付签名随机串，不长于 32 位
            package: config.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
            signType: config.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: config.sign, // 支付签名
            success: res => {
              let loadingComponent = Toast.loading('确认支付结果中...', {
                coverColor: 'rgba(0,0,0,0.5)'
              })
              // 支付成功后的回调函数
              let timeInterval = setInterval(() => {
                this.post({
                  url: config.url,
                  data: config.data
                }).then(r => {
                  if (r.data.paid == 1) {
                    loadingComponent.hide()
                    clearInterval(timeInterval)
                    resolve({
                      wxData: res,
                      data: r
                    })
                  }
                })
              }, 3000)
            },
            cancel: err => {
              //失败回调函数
              reject(err)
            },
            fail: err => {
              //失败回调函数
              reject(err)
            }
          })
        })
        wx.error(err => {
          reject(err)
          // config信息验证失败会执行error函数
        })
      })
    })
  },
}

/**
 * 接口返回错误码提示
 * @param status 0. 业务返回失败 1.返回成功 -1.没有权限
 * @param msg
 */
function message (status, msg = '') {
  switch (status) {
    case 0:
      Toast.fail(msg)
      break
    case 1:
      if (msg != (void 0) && msg != 'success' && msg != '') {
        Toast.fail(msg)
      }
      break
    case -1: {
      localStorage.removeItem('access_token')
      localStorage.removeItem('user')
      break
    }
    case -2:
      Toast.warn('暂无权限')
      break
    case 500:
      Toast.warn('服务器错误')
      break
  }
}

export default api



// WEBPACK FOOTER //
// ./src/Common/api.js